<script>
    // const imgURL='https://yueqiapi.vom-string.com/';
    const imgURL='http://localhost:9000/';
    
        export default
        {
            imgURL
        }
</script>